import { inject, Injectable } from "@angular/core";
import { NavigationEnd, NavigationCancel, NavigationError, Router } from "@angular/router";
import { filter, map, Observable, startWith } from "rxjs";
import { ProfileScreenEnum } from "../enums";
import { EDIT_URL_PATTERN, ME_EDIT_URL_PATTERN } from "../constants";

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  readonly #router = inject(Router);
  readonly isNavigationDone = (e: Event): boolean =>
    e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError;

  checkProfileScreen(featureUrl: string): Observable<ProfileScreenEnum> {
    return this.#router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
      startWith(this.#router.url),
      map((url) => {
        return url.includes(featureUrl) && (url.includes(EDIT_URL_PATTERN) || url.includes(ME_EDIT_URL_PATTERN))
          ? ProfileScreenEnum.Editing
          : ProfileScreenEnum.Viewing;
      }),
    );
  }
}
